import { createContext, useContext } from 'react';
import {
  AccessUser,
  CompanyInvoiceWithRelations,
  GigWithRelations,
  Job,
  PerDiemWithRelations,
  WithoutPermission,
  WithoutRestriction,
  WithPermission,
  WithRestriction,
} from '@utilities-one/api-sdk';

export type JobItemAccessTarget = {
  job?: {
    foremanId?: string | null;
    foreman?: { companyId?: string | null };
    project?: {
      definition?: {
        opms?: Array<{ id: string }>;
        coordinators?: Array<{ id: string }>;
        directorId?: string | null;
        state?: { market?: { division?: { ownerId?: string | null } } };
      } | null;
    };
  };
};

type ProjectAccessTarget = {
  definition?: {
    foremans?: Array<{ id: string }>;
    opms?: Array<{ id: string }>;
    coordinators?: Array<{ id: string }>;
    directorId?: string | null;
    state?: { market?: { division?: { ownerId?: string | null } } };
  };
  closeout?: { status?: string };
};

export interface AccessContextType {
  user: AccessUser;
  setUser: (user: AccessUser) => void;
  hasAccess: (accessKey: string) => boolean;
  hasPermission: (...permissions: string[]) => boolean;
  filterByPermissions: <T>(list: WithPermission<T>[]) => WithoutPermission<T>[];
  filterByRestrictions: <T>(list: WithRestriction<T>[]) => WithoutRestriction<T>[];
  isReadOnlyJob: (job: Pick<Job, 'foremanId'>) => boolean;
  foremanId: string | undefined;
  canActOnGig: (gig: Pick<GigWithRelations, 'foremanId' | 'technicianId' | 'jobItem'>) => boolean;
  canActOnInvoice: (invoice: Pick<CompanyInvoiceWithRelations, 'companyId' | 'project'>) => boolean;
  canActOnPerDiem: (perDiem: Pick<PerDiemWithRelations, 'opm' | 'director'>) => boolean;
  canActOnJobItem: (jobItem: JobItemAccessTarget) => boolean;
  canActOnProject: (project: ProjectAccessTarget) => boolean;
}

export const AccessContext = createContext<AccessContextType>({} as AccessContextType);

export const useAccess = () => useContext(AccessContext);
